/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Location_LabelInputs */

const en_video_export_location_label = /** @type {(inputs: Video_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video Export Location:`)
};

const fr_video_export_location_label = /** @type {(inputs: Video_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emplacement d'exportation video :`)
};

const de_video_export_location_label = /** @type {(inputs: Video_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speicherort für den Videoexport:`)
};

const it_video_export_location_label = /** @type {(inputs: Video_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione di esportazione video:`)
};

const ru_video_export_location_label = /** @type {(inputs: Video_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Место экспорта видео:`)
};

const es_video_export_location_label = /** @type {(inputs: Video_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación de exportación de video:`)
};

const zh_cn2_video_export_location_label = /** @type {(inputs: Video_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频导出位置：`)
};

const ja_video_export_location_label = /** @type {(inputs: Video_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオのエクスポート場所:`)
};

const hi_video_export_location_label = /** @type {(inputs: Video_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो निर्यात स्थान:`)
};

const pt_pt2_video_export_location_label = /** @type {(inputs: Video_Export_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local de exportação do vídeo:`)
};

/**
* | output |
* | --- |
* | "Video Export Location:" |
*
* @param {Video_Export_Location_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_location_label = /** @type {((inputs?: Video_Export_Location_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Location_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_location_label(inputs)
	if (locale === "de") return de_video_export_location_label(inputs)
	if (locale === "it") return it_video_export_location_label(inputs)
	if (locale === "ru") return ru_video_export_location_label(inputs)
	if (locale === "es") return es_video_export_location_label(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_location_label(inputs)
	if (locale === "ja") return ja_video_export_location_label(inputs)
	if (locale === "hi") return hi_video_export_location_label(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_location_label(inputs)
	return en_video_export_location_label(inputs)
});